import React from "react";
import styled from "styled-components";
import desktopBanner from "../assets/banners/banner-bienvenida-desktop.jpg";
import mobileBanner from "../assets/banners/banner-bienvenida-mobile.jpeg";

const CocaColaWelcome = () => {
  return (
    <FooterWrapper>
      <picture>
        <source media="(min-width: 769px)" srcSet={desktopBanner} />
        <BannerImage src={mobileBanner} alt="Coca-Cola Chile te da la bienvenida a AlmacenIA" />
      </picture>
    </FooterWrapper>
  );
};

export default CocaColaWelcome;

const FooterWrapper = styled.div`
  margin-top: clamp(12px, 2.5vw, 18px);
  padding: clamp(8px, 1.5vw, 12px) clamp(12px, 3vw, 20px);
  border-radius: 20px;
  background: transparent;
  text-align: center;
`;

const BannerImage = styled.img`
  display: block;
  width: 100%;
  max-width: 1200px;
  height: auto;
  margin: 0 auto;
  border-radius: 16px;

  @media (max-width: 768px) {
    max-width: 420px;
  }
`;
